import { Component, forwardRef, HostBinding, OnInit } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { DynamicComponentBase, IDynamicComponentConfig } from '../../../dynamic-component';

@Component({
  selector: 'app-d-number',
  templateUrl: './d-number.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DNumberComponent),
      multi: true
    }
  ]
})
export class DNumberComponent extends DynamicComponentBase {
  static KEY = 'd-number';

  // @HostBinding('style.float') float = 'left';

  constructor() {
    super();
  }

  configChange(config: IDynamicComponentConfig) {
    // if (typeof config.min !== 'number') {
    //   config.min = 0;
    // }
    // if (typeof config.max !== 'number') {
    //   config.max = 100;
    // }
    if (typeof config.step !== 'number') {
      config.step = 1;
    }
  }
}
